// extracted by mini-css-extract-plugin
export default {"musNavLink":"GestionTorneo_musNavLink__mJflc","musNavLinkDistributed":"GestionTorneo_musNavLinkDistributed__IeP3p"};